module.exports = __webpack_public_path__ + "statics/img/5.0f2e06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/5.png
// module id = RHDl
// module chunks = 1